/**
 * Outlook Integration Constants
 */

import type { QueryKey } from '@tanstack/react-query';

/** API routes for the firm-facing Outlook endpoints. */
export const OUTLOOK_API_ROUTES = {
  status: '/customer-integrations/email/outlook/status',
  adminConsentStart: '/customer-integrations/email/outlook/admin-consent/start',
  /**
   * Admin-only — mint a shareable authorisation link for the firm's external
   * Microsoft administrator, and kill the outstanding one. On the same
   * tenant-connection surface as `adminConsentStart`, because it is the same
   * firm-wide consent handed to a different pair of hands.
   */
  adminConsentHandoff:
    '/customer-integrations/email/outlook/admin-consent/handoff',
  adminConsentHandoffRevoke:
    '/customer-integrations/email/outlook/admin-consent/handoff/revoke',
  connect: '/customer-integrations/email/outlook/connect',
  /** Admin-only — how the firm sends matter email, chosen after consent. */
  sendIdentity: '/customer-integrations/email/outlook/send-identity',
  sharedMailboxConnect:
    '/customer-integrations/email/outlook/shared-mailbox/connect',
  reauthenticate: (connectionId: number): string =>
    `/customer-integrations/email/outlook/connections/${connectionId}/reauthenticate`,
  disconnect: (connectionId: number): string =>
    `/customer-integrations/email/outlook/connections/${connectionId}/disconnect`,
  /** Admin-only firm-level "off" switch — the counterpart to `adminConsentStart`. */
  disable: '/customer-integrations/email/outlook/disable'
} as const;

/** React Query key for the firm's Outlook status (firm is implicit via auth). */
export const OUTLOOK_STATUS_QUERY_KEY: QueryKey = [
  'outlook-integration',
  'status'
];
